<!-- src/components/GenericComponents/CopyrightFooter.vue -->
<template>
  <footer class="copyright-footer">
    <p class="copyright-text">
      © The33Path – All rights reserved. Unauthorized use, duplication or
      disclosure of these materials is strictly prohibited and may result in
      legal action.
    </p>
  </footer>
</template>

<script>
export default {
  name: "CopyrightFooter",
};
</script>

<style scoped>
.copyright-footer {
  width: 100%;
  padding: var(--space) var(--largeSpace);
  margin-top: auto;
  text-align: center;
}

.copyright-text {
  font-size: calc(var(--smallerFontSize) * 0.85);
  color: var(--grey-dark);
  opacity: 0.7;
  line-height: 1.4;
  margin: 0;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

/* Mobile adjustments */
@media only screen and (max-width: 480px) {
  .copyright-footer {
    padding: var(--smallSpace) var(--space);
  }

  .copyright-text {
    font-size: calc(var(--smallerFontSize) * 0.75);
  }
}
</style>
